import Update from "./update";
import DgModal from "../../../../custom/feedback/modal";


const EditParent = ({id, visible, onCancel, name, databaseKey})=>{


    return (
        <DgModal visible={visible}
                  width={700}
                  onCancel={() => onCancel()}
                  title={"Mã phiếu : " + name}
                  bodyStyle={{
                      minHeight: 100,
                      maxHeight: 600,
                      overflowY: "scroll",
                  }}
                  destroyOnClose={true}
                  okText={"Lưu"} >
            <Update id={id}
                    onCancel={()=>onCancel()}
                    databaseKey={databaseKey}/>
        </DgModal>
    )
}
export default EditParent
